import { render, staticRenderFns } from "./SpecialPriceAdjNew_Total.vue?vue&type=template&id=29467218&"
import script from "./SpecialPriceAdjNew_Total.vue?vue&type=script&lang=js&"
export * from "./SpecialPriceAdjNew_Total.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports